import type { PublicClientApplication, EventMessage } from '@azure/msal-browser'
import { EventType } from '@azure/msal-browser'
import { useMsalAuthStore } from '@stores/useMsalAuthStore'
import { getCachedM365Environment } from '@helpers/environmentHelpers'
import { getAccountForPortal } from '@config/auth/msalConfig'

export function attachMsalAuthSync(msal: PublicClientApplication) {
    // Teams authentication is held by the host, not in this window's MSAL cache.
    // Synchronizing an empty MSAL account list would undo a successful Teams sign-in.
    if (getCachedM365Environment().environment === 'Teams') {
        return () => undefined
    }

    const sync = () => {
        const count = getAccountForPortal(msal.getAllAccounts()) ? 1 : 0
        useMsalAuthStore.getState().setFromAccountCount(count)
    }

    // Initial sync
    sync()

    // Keep in sync on MSAL events
    const callbackId = msal.addEventCallback((message: EventMessage) => {
        switch (message.eventType) {
        case EventType.LOGIN_SUCCESS:
        case EventType.ACQUIRE_TOKEN_SUCCESS:
        case EventType.LOGOUT_SUCCESS:
        case EventType.ACCOUNT_ADDED:
        case EventType.ACCOUNT_REMOVED:
        case EventType.HANDLE_REDIRECT_END:
            sync()
            break
        }
    })

    return () => {
        if (callbackId) msal.removeEventCallback(callbackId)
    }
}
